import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { ALL_PEOPLE, establishmentNames, memberIssue, MockPerson, MockTeam } from '../../team-action-mock.data';

interface Candidate {
  person: MockPerson;
  establishments: string;
  issue: string | null;
  selected: boolean;
}

// Maquette d'estimation « action d'équipe » : ajout de membres, candidats non éligibles grisés avec leur raison.
@Component({
  selector: 'team-action-mock-team-member-add-modal',
  templateUrl: './team-action-mock-team-member-add-modal.component.html',
})
export class TeamActionMockTeamMemberAddModalComponent {
  readonly candidates: Candidate[];
  readonly perimeter: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { team: MockTeam },
    private dialogRef: MatDialogRef<TeamActionMockTeamMemberAddModalComponent>,
  ) {
    const { team } = data;
    this.perimeter = establishmentNames(team.support.clients);
    this.candidates = ALL_PEOPLE.filter(person => !team.members.includes(person))
      .map(person => ({
        person,
        establishments: establishmentNames(person.establishments),
        issue: memberIssue(person, team),
        selected: false,
      }))
      // Éligibles d'abord, pour que la liste se lise de haut en bas.
      .sort((a, b) => Number(a.issue !== null) - Number(b.issue !== null));
  }

  close(): void {
    this.dialogRef.close();
  }
}
